// extracted by mini-css-extract-plugin
export default {"main":"otp_main__qWgU-","container":"otp_container__x1uQc","wrapper":"otp_wrapper__Jb2Bp"};